import React from "react";
import { NavLink } from "react-router-dom";
import Icon from "../Icon";
import { unwrapRepeater } from "../../utils/CockpitUtils";
import "./style.scss";

const SubMenu = ({ items = [] }) => {
  items = unwrapRepeater(items);

  const isExternalUrl = /^https?:\/\//i;
  console.log("items:", items);

  return (
    <div className={"sub-menu"}>
      <ul>
        {items.map((item, j) => (
          <li key={j}>
            {isExternalUrl.test(item.url) ? (
              <a href={item.url} target="_blank" rel="noreferrer">
                <Icon
                  className="icon"
                  type={item.icon_style || "far"}
                  name={item.icon}
                />
                <span className="title">{item.text}</span>
              </a>
            ) : (
              <NavLink to={item.url}>
                <Icon
                  className="icon"
                  type={item.icon_style || "far"}
                  name={item.icon}
                />
                <span className="title">{item.text}</span>
              </NavLink>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SubMenu;
